import { PREFERENCES_API_BASE } from "./constants";

export default customerId => `${PREFERENCES_API_BASE}/${customerId}`;
